import getConfig from 'next/config';

const nextConfig = getConfig();

export const STATIC_REWRITE_PATHS = {
    [(nextConfig?.publicRuntimeConfig?.domains?.[0]?.url ||
        process.env.DOMAIN_HOSTNAME_1 ||
        'smokeTestDomain') as string]: {
        '/search': '/hledani',
        '/cart': '/kosik',
        '/order/transport-and-payment': '/objednavka/doprava-a-platba',
        '/order/contact-information': '/objednavka/kontaktni-udaje',
        '/reset-password': '/zapomenute-heslo',
        '/order-confirmation': '/potvrzeni-objednavky',
        '/stores': '/prodejny',
        '/contact': '/kontakty',
        '/product-lines': '/produktove-linie',
        '/catalog': '/katalog',
        '/login': '/prihlaseni',
        '/customer': '/zakaznik',
        '/customer/edit-profile': '/zakaznik/upravit-udaje',
        '/customer/orders': '/zakaznik/objednavky',
        '/customer/order-detail': '/zakaznik/detail-objednavky',
        '/customer/exchange-office': '/zakaznik/smenarna',
        '/customer/my-points': '/zakaznik/moje-body',
        '/customer/watched-items': '/zakaznik/hlidane-polozky',
        '/customer/claims-and-returns': '/zakaznik/reklamace-a-vraceni',
        '/customer/order-claim': '/zakaznik/reklamace',
        '/customer/order-return': '/zakaznik/vraceni-zbozi',
        '/registration': '/registrace',
        '/terms-and-conditions': '/obchodni-podminky',
        '/gdpr': '/zasady-ochrany-osobnich-udaju',
        '/recover-password': '/nove-heslo',
        '/personal-data-overview': '/prehled-osobnich-udaju',
        '/personal-data-overview/:hash': '/prehled-osobnich-udaju/:hash',
        '/personal-data-export': '/export-osobnich-udaju',
        '/order-payment-confirmation': '/potvrzeni-platby-objednavky',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detail-objednavky/:urlHash',
        '/cookie-consent': '/souhlas-se-soubory-cookies',
        '/abandoned-cart/:cartUuid': '/kosik/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/platebni-brana',
        '/maintenance': '/udrzba',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/oblibene-produkty',
        '/order-claim/detail/:urlHash': '/reklamace/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamace/nova/:urlHash',
        '/order-return/detail/:urlHash': '/vraceni-zbozi/detail/:urlHash',
        '/order-return/new/:urlHash': '/vraceni-zbozi/nove/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamace/potvrzeni/:urlHash',
        '/order-return/confirmation/:urlHash': '/vraceni-zbozi/potvrzeni/:urlHash',
        '/claims-and-returns': '/reklamace-a-vraceni',
        '/legal-guarantee-notice': '/harmonizovane-oznameni-zakonna-zaruka',
    },
    [(nextConfig?.publicRuntimeConfig?.domains?.[1]?.url ||
        process.env.DOMAIN_HOSTNAME_2 ||
        'cypressTestB2bDomain') as string]: {
        '/search': '/hledani',
        '/cart': '/kosik',
        '/order/transport-and-payment': '/objednavka/doprava-a-platba',
        '/order/contact-information': '/objednavka/kontaktni-udaje',
        '/b2b-reset-password': '/zapomenute-heslo',
        '/order-confirmation': '/potvrzeni-objednavky',
        '/stores': '/prodejny',
        '/contact': '/kontakty',
        '/product-lines': '/produktove-linie',
        '/catalog': '/katalog',
        '/b2b-login': '/prihlaseni',
        '/customer': '/zakaznik',
        '/customer/edit-profile': '/zakaznik/upravit-udaje',
        '/customer/order-detail': '/zakaznik/detail-objednavky',
        '/customer/exchange-office': '/zakaznik/smenarna',
        '/customer/watched-items': '/zakaznik/hlidane-polozky',
        '/customer/b2b-orders': '/zakaznik/objednavky',
        '/customer/b2b-documents': '/zakaznik/dokumenty',
        '/customer/claims-and-returns': '/zakaznik/reklamace-a-vraceni',
        '/customer/order-claim': '/zakaznik/reklamace',
        '/customer/order-return': '/zakaznik/vraceni-zbozi',
        '/registration': '/registrace',
        '/terms-and-conditions': '/obchodni-podminky',
        '/gdpr': '/zasady-ochrany-osobnich-udaju',
        '/b2b-recover-password': '/nove-heslo',
        '/personal-data-overview': '/prehled-osobnich-udaju',
        '/personal-data-overview/:hash': '/prehled-osobnich-udaju/:hash',
        '/personal-data-export': '/export-osobnich-udaju',
        '/order-payment-confirmation': '/potvrzeni-platby-objednavky',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detail-objednavky/:urlHash',
        '/cookie-consent': '/souhlas-se-soubory-cookies',
        '/abandoned-cart/:cartUuid': '/kosik/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/platebni-brana',
        '/social-login': '/social-login',
        '/maintenance': '/udrzba',
        '/wishlist': '/oblibene-produkty',
        '/b2b-quick-order': '/rychla-objednavka',
        '/order-claim/detail/:urlHash': '/reklamace/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamace/nova/:urlHash',
        '/order-return/detail/:urlHash': '/vraceni-zbozi/detail/:urlHash',
        '/order-return/new/:urlHash': '/vraceni-zbozi/nove/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamace/potvrzeni/:urlHash',
        '/order-return/confirmation/:urlHash': '/vraceni-zbozi/potvrzeni/:urlHash',
        '/claims-and-returns': '/reklamace-a-vraceni',
        '/legal-guarantee-notice': '/harmonizovane-oznameni-zakonna-zaruka',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[2]?.url || process.env.DOMAIN_HOSTNAME_3]: {
        '/search': '/hladanie',
        '/cart': '/kosik',
        '/order/transport-and-payment': '/objednavka/doprava-a-platba',
        '/order/contact-information': '/objednavka/kontaktne-udaje',
        '/reset-password': '/zapomenute-heslo',
        '/order-confirmation': '/potvrdenie-objednavky',
        '/stores': '/predajne',
        '/contact': '/kontakty',
        '/product-lines': '/produktove-linie',
        '/catalog': '/katalog',
        '/login': '/prihlasenie',
        '/customer': '/zakaznik',
        '/customer/edit-profile': '/zakaznik/upravit-udaje',
        '/customer/orders': '/zakaznik/objednavky',
        '/customer/order-detail': '/zakaznik/detail-objednavky',
        '/customer/exchange-office': '/zakaznik/smenarna',
        '/customer/my-points': '/zakaznik/moje-body',
        '/customer/watched-items': '/zakaznik/hlidane-polozky',
        '/customer/claims-and-returns': '/zakaznik/reklamacie-a-vratenie',
        '/customer/order-claim': '/zakaznik/reklamacia',
        '/customer/order-return': '/zakaznik/vratenie-tovaru',
        '/registration': '/registracia',
        '/terms-and-conditions': '/podmienky-a-ustanovenia',
        '/gdpr': '/zasady-ochrany-osobnych-udajov',
        '/recover-password': '/nove-heslo',
        '/personal-data-overview': '/prehlad-osobnych-udajov',
        '/personal-data-overview/:hash': '/prehlad-osobnych-udajov/:hash',
        '/personal-data-export': '/export-osobnych-udajov',
        '/order-payment-confirmation': '/potvrdenie-platby-objednavky',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detail-objednavky/:urlHash',
        '/cookie-consent': '/suhlas-so-subormi-cookies',
        '/abandoned-cart/:cartUuid': '/kosik/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/platobna-brana',
        '/maintenance': '/udrzba',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/oblubene-produkty',
        '/order-claim/detail/:urlHash': '/reklamacia/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamacia/nova/:urlHash',
        '/order-return/detail/:urlHash': '/vratenie-tovaru/detail/:urlHash',
        '/order-return/new/:urlHash': '/vratenie-tovaru/nove/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamacia/potvrdenie/:urlHash',
        '/order-return/confirmation/:urlHash': '/vratenie-tovaru/potvrdenie/:urlHash',
        '/claims-and-returns': '/reklamacie-a-vratenie',
        '/legal-guarantee-notice': '/harmonizovane-oznamenie-zakonna-zaruka',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[3]?.url || process.env.DOMAIN_HOSTNAME_4]: {
        '/search': '/hladanie',
        '/cart': '/kosik',
        '/order/transport-and-payment': '/objednavka/doprava-a-platba',
        '/order/contact-information': '/objednavka/kontaktne-udaje',
        '/b2b-reset-password': '/zapomenute-heslo',
        '/order-confirmation': '/potvrdenie-objednavky',
        '/stores': '/predajne',
        '/contact': '/kontakty',
        '/product-lines': '/produktove-linie',
        '/catalog': '/katalog',
        '/b2b-login': '/prihlasenie',
        '/customer': '/zakaznik',
        '/customer/edit-profile': '/zakaznik/upravit-udaje',
        '/customer/order-detail': '/zakaznik/detail-objednavky',
        '/customer/exchange-office': '/zakaznik/smenarna',
        '/customer/watched-items': '/zakaznik/hlidane-polozky',
        '/customer/b2b-orders': '/zakaznik/objednavky',
        '/customer/b2b-documents': '/zakaznik/dokumenty',
        '/customer/claims-and-returns': '/zakaznik/reklamacie-a-vratenie',
        '/customer/order-claim': '/zakaznik/reklamacia',
        '/customer/order-return': '/zakaznik/vratenie-tovaru',
        '/registration': '/registracia',
        '/terms-and-conditions': '/podmienky-a-ustanovenia',
        '/gdpr': '/zasady-ochrany-osobnych-udajov',
        '/b2b-recover-password': '/nove-heslo',
        '/personal-data-overview': '/prehlad-osobnych-udajov',
        '/personal-data-overview/:hash': '/prehlad-osobnych-udajov/:hash',
        '/personal-data-export': '/export-osobnych-udajov',
        '/order-payment-confirmation': '/potvrdenie-platby-objednavky',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detail-objednavky/:urlHash',
        '/cookie-consent': '/suhlas-so-subormi-cookies',
        '/abandoned-cart/:cartUuid': '/kosik/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/platobna-brana',
        '/maintenance': '/udrzba',
        '/social-login': '/social-login',
        '/wishlist': '/oblubene-produkty',
        '/b2b-quick-order': '/rychla-objednavka',
        '/order-claim/detail/:urlHash': '/reklamacia/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamacia/nova/:urlHash',
        '/order-return/detail/:urlHash': '/vratenie-tovaru/detail/:urlHash',
        '/order-return/new/:urlHash': '/vratenie-tovaru/nove/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamacia/potvrdenie/:urlHash',
        '/order-return/confirmation/:urlHash': '/vratenie-tovaru/potvrdenie/:urlHash',
        '/claims-and-returns': '/reklamacie-a-vratenie',
        '/legal-guarantee-notice': '/harmonizovane-oznamenie-zakonna-zaruka',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[4]?.url || process.env.DOMAIN_HOSTNAME_5]: {
        '/search': '/wyszukiwanie',
        '/cart': '/koszyk',
        '/order/transport-and-payment': '/zamowienie/dostawa-i-platnosc',
        '/order/contact-information': '/zamowienie/dane-kontaktowe',
        '/reset-password': '/resetowanie-hasla',
        '/order-confirmation': '/potwierzenie-zamowienia',
        '/stores': '/sklepy',
        '/contact': '/kontakty',
        '/product-lines': '/linie-produktowe',
        '/catalog': '/katalog',
        '/login': '/logowanie',
        '/customer': '/klient',
        '/customer/edit-profile': '/klient/edycja-danych',
        '/customer/orders': '/klient/zamowienia',
        '/customer/order-detail': '/klient/szczegoly-zamowienia',
        '/customer/exchange-office': '/klient/kantor',
        '/customer/my-points': '/klient/moje-punkty',
        '/customer/watched-items': '/klient/sledzone-produkty',
        '/customer/claims-and-returns': '/klient/reklamacje-i-zwroty',
        '/customer/order-claim': '/klient/reklamacja',
        '/customer/order-return': '/klient/zwrot-produktow',
        '/registration': '/rejestracja',
        '/terms-and-conditions': '/regulamin-sklepu',
        '/gdpr': '/informacje-o-przetwarzaniu-danych-osobowych',
        '/recover-password': '/nowe-haslo',
        '/personal-data-overview': '/przeglad-danych-osobowych',
        '/personal-data-overview/:hash': '/przeglada-danych-osobowych/:hash',
        '/personal-data-export': '/eksport-danych-osobowych',
        '/order-payment-confirmation': '/potwierdzenie-platnosci-za-zamowienie',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/szczegoly-zamowienia/:urlHash',
        '/cookie-consent': '/zgodna-na-pliki-cookies',
        '/abandoned-cart/:cartUuid': '/kosik/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/bramka-platnosci',
        '/maintenance': '/konserwacja',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/popularne-produkty',
        '/order-claim/detail/:urlHash': '/reklamacja/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamacja/nowa/:urlHash',
        '/order-return/detail/:urlHash': '/zwrot-produktow/szczegoly/:urlHash',
        '/order-return/new/:urlHash': '/zwrot-produktow/nowy/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamacja/potwierdzenie/:urlHash',
        '/order-return/confirmation/:urlHash': '/zwrot-produktow/potwierdzenie/:urlHash',
        '/claims-and-returns': '/reklamacje-i-zwroty',
        '/legal-guarantee-notice': '/zharmonizowane-zawiadomienie-gwarancja-prawna',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[5]?.url || process.env.DOMAIN_HOSTNAME_6]: {
        '/search': '/wyszukiwanie',
        '/cart': '/koszyk',
        '/order/transport-and-payment': '/zamowienie/dostawa-i-platnosc',
        '/order/contact-information': '/zamowienie/dane-kontaktowe',
        '/b2b-reset-password': '/resetowanie-hasla',
        '/order-confirmation': '/potwierzenie-zamowienia',
        '/stores': '/sklepy',
        '/contact': '/kontakty',
        '/product-lines': '/linie-produktowe',
        '/catalog': '/katalog',
        '/b2b-login': '/logowanie',
        '/customer': '/klient',
        '/customer/edit-profile': '/klient/edycja-danych',
        '/customer/order-detail': '/klient/szczegoly-zamowienia',
        '/customer/exchange-office': '/klient/kantor',
        '/customer/watched-items': '/klient/sledzone-produkty',
        '/customer/b2b-orders': '/klient/zamowienia',
        '/customer/b2b-documents': '/klient/dokumenty',
        '/customer/claims-and-returns': '/klient/reklamacje-i-zwroty',
        '/customer/order-claim': '/klient/reklamacja',
        '/customer/order-return': '/klient/zwrot-produktow',
        '/registration': '/rejestracja',
        '/terms-and-conditions': '/regulamin-sklepu',
        '/gdpr': '/informacje-o-przetwarzaniu-danych-osobowych',
        '/b2b-recover-password': '/nowe-haslo',
        '/personal-data-overview': '/przeglad-danych-osobowych',
        '/personal-data-overview/:hash': '/przeglada-danych-osobowych/:hash',
        '/personal-data-export': '/eksport-danych-osobowych',
        '/order-payment-confirmation': '/potwierdzenie-platnosci-za-zamowienie',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/szczegoly-zamowienia/:urlHash',
        '/cookie-consent': '/zgodna-na-pliki-cookies',
        '/abandoned-cart/:cartUuid': '/kosik/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/bramka-platnosci',
        '/maintenance': '/konserwacja',
        '/social-login': '/social-login',
        '/wishlist': '/popularne-produkty',
        '/b2b-quick-order': '/szybkie-zamowienie',
        '/order-claim/detail/:urlHash': '/reklamacja/szczegoly/:urlHash',
        '/order-claim/new/:urlHash': '/reklamacja/nowa/:urlHash',
        '/order-return/detail/:urlHash': '/zwrot-produktow/szczegoly/:urlHash',
        '/order-return/new/:urlHash': '/zwrot-produktow/nowy/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamacja/potwierdzenie/:urlHash',
        '/order-return/confirmation/:urlHash': '/zwrot-produktow/potwierdzenie/:urlHash',
        '/claims-and-returns': '/reklamacje-i-zwroty',
        '/legal-guarantee-notice': '/zharmonizowane-zawiadomienie-gwarancja-prawna',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[6]?.url || process.env.DOMAIN_HOSTNAME_7]: {
        '/search': '/kereses',
        '/cart': '/kosar',
        '/order/transport-and-payment': '/rendeles/szallitas-es-fizetes',
        '/order/contact-information': '/rendeles/elerhetosegek',
        '/reset-password': '/elfelejtett-jelszo',
        '/order-confirmation': '/rendeles-megerositese',
        '/stores': '/boltok',
        '/contact': '/kapcsolat-1',
        '/product-lines': '/termekcsaladok',
        '/catalog': '/katalogus',
        '/login': '/bejelentkezes',
        '/customer': '/ugyfel',
        '/customer/edit-profile': '/ugyfel/adatok-szerkesztese',
        '/customer/orders': '/ugyfel/megrendelesek',
        '/customer/order-detail': '/ugyfel/megrendeles-reszletei',
        '/customer/exchange-office': '/ugyfel/penzvalto',
        '/customer/my-points': '/ugyfel/pontjaim',
        '/customer/watched-items': '/ugyfel/kovetett-tetelek',
        '/customer/claims-and-returns': '/ugyfel/reklamaciok-es-visszakuldesek',
        '/customer/order-claim': '/ugyfel/reklamacio',
        '/customer/order-return': '/ugyfel/aru-visszakuldes',
        '/registration': '/registracio',
        '/terms-and-conditions': '/aszf',
        '/gdpr': '/adatkezelesi-tajekoztato',
        '/recover-password': '/uj-jelszo',
        '/personal-data-overview': '/szemelyes-adatok',
        '/personal-data-overview/:hash': '/szemelyes-adatok/:hash',
        '/personal-data-export': '/szemelyes-adatok-export',
        '/order-payment-confirmation': '/megrendeles-fizetes-megerositese',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/megrendeles-reszletei/:urlHash',
        '/cookie-consent': '/sutik-hozzajarulas',
        '/abandoned-cart/:cartUuid': '/kosar/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/fizetesi-atjaro',
        '/maintenance': '/karbantartás',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/nepszeru-termekek',
        '/order-claim/detail/:urlHash': '/reklamacio/reszletek/:urlHash',
        '/order-claim/new/:urlHash': '/reklamacio/uj/:urlHash',
        '/order-return/detail/:urlHash': '/aru-visszakuldes/reszletek/:urlHash',
        '/order-return/new/:urlHash': '/aru-visszakuldes/uj/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamacio/megerosites/:urlHash',
        '/order-return/confirmation/:urlHash': '/aru-visszakuldes/megerosites/:urlHash',
        '/claims-and-returns': '/reklamaciok-es-visszakuldesek',
        '/legal-guarantee-notice': '/harmonizalt-tajekoztato-jogszabalyi-jotallas',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[7]?.url || process.env.DOMAIN_HOSTNAME_8]: {
        '/search': '/kereses',
        '/cart': '/kosar',
        '/order/transport-and-payment': '/rendeles/szallitas-es-fizetes',
        '/order/contact-information': '/rendeles/elerhetosegek',
        '/b2b-reset-password': '/elfelejtett-jelszo',
        '/order-confirmation': '/rendeles-megerositese',
        '/stores': '/boltok',
        '/contact': '/kapcsolat',
        '/product-lines': '/termekcsaladok',
        '/catalog': '/katalogus',
        '/b2b-login': '/bejelentkezes',
        '/customer': '/ugyfel',
        '/customer/edit-profile': '/ugyfel/adatok-szerkesztese',
        '/customer/order-detail': '/ugyfel/megrendeles-reszletei',
        '/customer/exchange-office': '/ugyfel/penzvalto',
        '/customer/watched-items': '/ugyfel/kovetett-tetelek',
        '/customer/b2b-orders': '/ugyfel/megrendelesek',
        '/customer/b2b-documents': '/ugyfel/dokumentumok',
        '/customer/claims-and-returns': '/ugyfel/reklamaciok-es-visszakuldesek',
        '/customer/order-claim': '/ugyfel/reklamacio',
        '/customer/order-return': '/ugyfel/aru-visszakuldes',
        '/registration': '/registracio',
        '/terms-and-conditions': '/aszf',
        '/gdpr': '/adatkezelesi-tajekoztato',
        '/b2b-recover-password': '/uj-jelszo',
        '/personal-data-overview': '/szemelyes-adatok',
        '/personal-data-overview/:hash': '/szemelyes-adatok/:hash',
        '/personal-data-export': '/szemelyes-adatok-export',
        '/order-payment-confirmation': '/megrendeles-fizetes-megerositese',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/megrendeles-reszletei/:urlHash',
        '/cookie-consent': '/sutik-hozzajarulas',
        '/abandoned-cart/:cartUuid': '/kosar/:cartUuid',
        '/tescoma-club': '/tescoma-klub',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/fizetesi-atjaro',
        '/maintenance': '/karbantartás',
        '/social-login': '/social-login',
        '/wishlist': '/nepszeru-termekek',
        '/b2b-quick-order': '/gyors-rendeles',
        '/order-claim/detail/:urlHash': '/reklamacio/reszletek/:urlHash',
        '/order-claim/new/:urlHash': '/reklamacio/uj/:urlHash',
        '/order-return/detail/:urlHash': '/aru-visszakuldes/reszletek/:urlHash',
        '/order-return/new/:urlHash': '/aru-visszakuldes/uj/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamacio/megerosites/:urlHash',
        '/order-return/confirmation/:urlHash': '/aru-visszakuldes/megerosites/:urlHash',
        '/claims-and-returns': '/reklamaciok-es-visszakuldesek',
        '/legal-guarantee-notice': '/harmonizalt-tajekoztato-jogszabalyi-jotallas',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[8]?.url || process.env.DOMAIN_HOSTNAME_9]: {
        '/search': '/suche',
        '/cart': '/warenkorb',
        '/order/transport-and-payment': '/bestellung/versand-und-zahlung',
        '/order/contact-information': '/bestellung/kundendaten',
        '/reset-password': '/passwort-zurucksetzen',
        '/order-confirmation': '/bestellbestaetigung',
        '/stores': '/stores',
        '/contact': '/kontaktformular',
        '/product-lines': '/produkt-serien',
        '/catalog': '/katalog',
        '/login': '/login',
        '/customer': '/kundenkonto',
        '/customer/edit-profile': '/kundenkonto/daten-bearbeiten',
        '/customer/orders': '/kundenkonto/bestellungen',
        '/customer/order-detail': '/kundenkonto/bestelldetails',
        '/customer/exchange-office': '/kundenkonto/exchange-office',
        '/customer/my-points': '/kundenkonto/meine-punkte',
        '/customer/watched-items': '/kundenkonto/merkliste',
        '/customer/claims-and-returns': '/kundenkonto/reklamationen-und-rueckgaben',
        '/customer/order-claim': '/kundenkonto/reklamation',
        '/customer/order-return': '/kundenkonto/waren-rueckgabe',
        '/registration': '/registrierung',
        '/terms-and-conditions': '/agb',
        '/gdpr': '/gdpr',
        '/recover-password': '/passwort-wiederherstellen',
        '/personal-data-overview': '/kundendaten-uebersicht',
        '/personal-data-overview/:hash': '/kundendaten-uebersicht/:hash',
        '/personal-data-export': '/kundendaten-export',
        '/order-payment-confirmation': '/bestellung-zahlungsbestaetigung',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/bestelldetails/:urlHash',
        '/cookie-consent': '/cookie-zustimmung',
        '/abandoned-cart/:cartUuid': '/verlassener-Warenkorb/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/zahlungs-gateways',
        '/maintenance': '/wartung',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/beliebte-produkte',
        '/order-claim/detail/:urlHash': '/reklamation/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamation/neu/:urlHash',
        '/order-return/detail/:urlHash': '/waren-rueckgabe/detail/:urlHash',
        '/order-return/new/:urlHash': '/waren-rueckgabe/neu/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamation/bestaetigung/:urlHash',
        '/order-return/confirmation/:urlHash': '/waren-rueckgabe/bestaetigung/:urlHash',
        '/claims-and-returns': '/reklamationen-und-rueckgaben',
        '/legal-guarantee-notice': '/harmonisierte-mitteilung-gesetzliche-gewaehrleistung',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[9]?.url || process.env.DOMAIN_HOSTNAME_10]: {
        '/search': '/suche',
        '/cart': '/warenkorb',
        '/order/transport-and-payment': '/bestellung/versand-und-zahlung',
        '/order/contact-information': '/bestellung/kundendaten',
        '/b2b-reset-password': '/passwort-zurucksetzen',
        '/order-confirmation': '/bestellbestaetigung',
        '/stores': '/stores',
        '/contact': '/kontaktformular',
        '/product-lines': '/produkt-serien',
        '/catalog': '/katalog',
        '/b2b-login': '/einloggen',
        '/customer': '/kundenkonto',
        '/customer/edit-profile': '/kundenkonto/daten-bearbeiten',
        '/customer/order-detail': '/kundenkonto/bestelldetails',
        '/customer/exchange-office': '/kundenkonto/exchange-office',
        '/customer/watched-items': '/kundenkonto/merkliste',
        '/customer/b2b-orders': '/kundenkonto/bestellungen',
        '/customer/b2b-documents': '/kundenkonto/dokumenten',
        '/customer/claims-and-returns': '/kundenkonto/reklamationen-und-rueckgaben',
        '/customer/order-claim': '/kundenkonto/reklamation',
        '/customer/order-return': '/kundenkonto/waren-rueckgabe',
        '/registration': '/registrierung',
        '/terms-and-conditions': '/agb',
        '/gdpr': '/gdpr',
        '/b2b-recover-password': '/passwort-wiederherstellen',
        '/personal-data-overview': '/kundendaten-uebersicht',
        '/personal-data-overview/:hash': '/kundendaten-uebersicht/:hash',
        '/personal-data-export': '/kundendaten-export',
        '/order-payment-confirmation': '/bestellung-zahlungsbestaetigung',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/bestelldetails/:urlHash',
        '/cookie-consent': '/cookie-zustimmung',
        '/abandoned-cart/:cartUuid': '/verlassener-Warenkorb/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/zahlungs-gateways',
        '/maintenance': '/wartung',
        '/social-login': '/social-login',
        '/wishlist': '/beliebte-produkte',
        '/b2b-quick-order': '/schnellbestellung',
        '/order-claim/detail/:urlHash': '/reklamation/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamation/neu/:urlHash',
        '/order-return/detail/:urlHash': '/waren-rueckgabe/detail/:urlHash',
        '/order-return/new/:urlHash': '/waren-rueckgabe/neu/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamation/bestaetigung/:urlHash',
        '/order-return/confirmation/:urlHash': '/waren-rueckgabe/bestaetigung/:urlHash',
        '/claims-and-returns': '/reklamationen-und-rueckgaben',
        '/legal-guarantee-notice': '/harmonisierte-mitteilung-gesetzliche-gewaehrleistung',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[10]?.url || process.env.DOMAIN_HOSTNAME_11]: {
        '/search': '/buscar',
        '/cart': '/carrito',
        '/order/transport-and-payment': '/pedido/transporte-y-pago',
        '/order/contact-information': '/pedido/informacion-de-contacto',
        '/reset-password': '/restablecer-contrasena',
        '/order-confirmation': '/pedido-confirmado',
        '/stores': '/tiendas',
        '/contact': '/contactanos',
        '/product-lines': '/lineas-de-producto',
        '/catalog': '/catalogo',
        '/login': '/iniciar-sesion/registro',
        '/customer': '/cliente',
        '/customer/edit-profile': '/cliente/editar-datos',
        '/customer/orders': '/cliente/pedidos',
        '/customer/order-detail': '/cliente/detalles-pedido',
        '/customer/exchange-office': '/cliente/devolucion',
        '/customer/my-points': '/cliente/mis-puntos',
        '/customer/watched-items': '/cliente/productos-vistos',
        '/customer/claims-and-returns': '/cliente/reclamaciones-y-devoluciones',
        '/customer/order-claim': '/cliente/reclamacion',
        '/customer/order-return': '/cliente/devolucion-productos',
        '/registration': '/registro',
        '/terms-and-conditions': '/terminos-y-condiciones',
        '/gdpr': '/rgpd',
        '/recover-password': '/recuperar-contrasena',
        '/personal-data-overview': '/resumen-datos-personales',
        '/personal-data-overview/:hash': '/resumen-datos-personales/:hash',
        '/personal-data-export': '/exportacion-datos-personales',
        '/order-payment-confirmation': '/pedido-confirmacion-pago',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detalles-pedido/:urlHash',
        '/cookie-consent': '/consentimiento-de-cookies',
        '/abandoned-cart/:cartUuid': '/carrito-abandonado/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/pasarela-de-pago',
        '/maintenance': '/manutenzione',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/productos-populares',
        '/order-claim/detail/:urlHash': '/reclamacion/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamacion/nueva/:urlHash',
        '/order-return/detail/:urlHash': '/devolucion-productos/detail/:urlHash',
        '/order-return/new/:urlHash': '/devolucion-productos/nueva/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamacion/confirmacion/:urlHash',
        '/order-return/confirmation/:urlHash': '/devolucion-productos/confirmacion/:urlHash',
        '/claims-and-returns': '/reclamaciones-y-devoluciones',
        '/legal-guarantee-notice': '/aviso-armonizado-garantia-legal',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[11]?.url || process.env.DOMAIN_HOSTNAME_12]: {
        '/search': '/pesquisar',
        '/cart': '/carrinho',
        '/order/transport-and-payment': '/encomenda/transporte-e-pagamento',
        '/order/contact-information': '/encomenda/informacao-contacto',
        '/reset-password': '/redefinir-password',
        '/order-confirmation': '/confirmacao-encomenda',
        '/stores': '/lojas',
        '/contact': '/contacto',
        '/product-lines': '/linhas-produtos',
        '/catalog': '/catalogo',
        '/login': '/login',
        '/customer': '/cliente',
        '/customer/edit-profile': '/cliente/editar-datos',
        '/customer/orders': '/cliente/encomendas',
        '/customer/order-detail': '/cliente/detalhes-encomenda',
        '/customer/exchange-office': '/cliente/cambio',
        '/customer/my-points': '/cliente/meus-pontos',
        '/customer/watched-items': '/cliente/produtos-visualizados',
        '/customer/claims-and-returns': '/cliente/reclamacoes-e-devolucoes',
        '/customer/order-claim': '/cliente/reclamacao',
        '/customer/order-return': '/cliente/devolucao-produtos',
        '/registration': '/registo',
        '/terms-and-conditions': '/termos-e-condicoes',
        '/gdpr': '/rgpd',
        '/recover-password': '/recuperar-password',
        '/personal-data-overview': '/vista-dados-pessoais',
        '/personal-data-overview/:hash': '/vista-dados-pessoais/:hash',
        '/personal-data-export': '/exportacao-dados-pessoais',
        '/order-payment-confirmation': '/confirmacao-pagamento-encomenda',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detalhes-encomenda/:urlHash',
        '/cookie-consent': '/consentimento-cookies',
        '/abandoned-cart/:cartUuid': '/carrinho-abandonado/:cartUuid',
        '/tescoma-club': '/club-tescoma',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/gateway-de-pagamento',
        '/maintenance': '/manutenzione',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/produtos-populares',
        '/order-claim/detail/:urlHash': '/reclamacao/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamacao/nova/:urlHash',
        '/order-return/detail/:urlHash': '/devolucao-produtos/detail/:urlHash',
        '/order-return/new/:urlHash': '/devolucao-produtos/nova/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamacao/confirmacao/:urlHash',
        '/order-return/confirmation/:urlHash': '/devolucao-produtos/confirmacao/:urlHash',
        '/claims-and-returns': '/reclamacoes-e-devolucoes',
        '/legal-guarantee-notice': '/aviso-harmonizado-garantia-legal',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[12]?.url || process.env.DOMAIN_HOSTNAME_13]: {
        '/search': '/search',
        '/stores': '/stores',
        '/contact': '/contacts',
        '/product-lines': '/product-lines',
        '/catalog': '/catalogue',
        '/terms-and-conditions': '/terms-and-conditions',
        '/gdpr': '/gdpr',
        '/personal-data-overview': '/personal-data-overview',
        '/personal-data-overview/:hash': '/personal-data-overview/:hash',
        '/personal-data-export': '/personal-data-export',
        '/cookie-consent': '/cookie-consent',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/wishlist',
        '/customer/claims-and-returns': '/customer/claims-and-returns',
        '/customer/order-claim': '/customer/claim',
        '/customer/order-return': '/customer/return',
        '/order-claim/detail/:urlHash': '/claim/detail/:urlHash',
        '/order-claim/new/:urlHash': '/claim/new/:urlHash',
        '/order-return/detail/:urlHash': '/return/detail/:urlHash',
        '/order-return/new/:urlHash': '/return/new/:urlHash',
        '/order-claim/confirmation/:urlHash': '/claim/confirmation/:urlHash',
        '/order-return/confirmation/:urlHash': '/return/confirmation/:urlHash',
        '/claims-and-returns': '/claims-and-returns',
        '/legal-guarantee-notice': '/harmonised-notice-legal-guarantee',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[13]?.url || process.env.DOMAIN_HOSTNAME_14]: {
        '/search': '/ricerca',
        '/stores': '/negozi',
        '/contact': '/contattateci',
        '/product-lines': '/linee-di-prodotti',
        '/catalog': '/catalogo',
        '/terms-and-conditions': '/termini-e-condizioni',
        '/gdpr': '/regolamento-gdpr',
        '/personal-data-overview': '/panoramica-dati-personali',
        '/personal-data-overview/:hash': '/panoramica-dati-personali/:hash',
        '/personal-data-export': '/esportazione-dati-personali',
        '/cookie-consent': '/consenso-cookie',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/prodotti-richiesti',
        '/customer/claims-and-returns': '/cliente/reclami-e-resi',
        '/customer/order-claim': '/cliente/reclamo',
        '/customer/order-return': '/cliente/reso-prodotti',
        '/order-claim/detail/:urlHash': '/reclamo/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamo/nuovo/:urlHash',
        '/order-return/detail/:urlHash': '/reso-prodotti/detail/:urlHash',
        '/order-return/new/:urlHash': '/reso-prodotti/nuovo/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamo/conferma/:urlHash',
        '/order-return/confirmation/:urlHash': '/reso-prodotti/conferma/:urlHash',
        '/claims-and-returns': '/reclami-e-resi',
        '/legal-guarantee-notice': '/avviso-armonizzato-garanzia-legale',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[14]?.url || process.env.DOMAIN_HOSTNAME_15]: {
        '/search': '/suche',
        '/cart': '/warenkorb',
        '/order/transport-and-payment': '/bestellung/versand-und-zahlung',
        '/order/contact-information': '/bestellung/kundendaten',
        '/reset-password': '/passwort-zurucksetzen',
        '/order-confirmation': '/bestellbestaetigung',
        '/stores': '/stores',
        '/contact': '/kontaktformular',
        '/product-lines': '/produkt-serien',
        '/catalog': '/katalog',
        '/login': '/login',
        '/customer': '/kundenkonto',
        '/customer/edit-profile': '/kundenkonto/daten-bearbeiten',
        '/customer/orders': '/kundenkonto/bestellungen',
        '/customer/order-detail': '/kundenkonto/bestelldetails',
        '/customer/exchange-office': '/kundenkonto/exchange-office',
        '/customer/my-points': '/kundenkonto/meine-punkte',
        '/customer/watched-items': '/kundenkonto/merkliste',
        '/customer/claims-and-returns': '/kundenkonto/reklamationen-und-rueckgaben',
        '/customer/order-claim': '/kundenkonto/reklamation',
        '/customer/order-return': '/kundenkonto/waren-rueckgabe',
        '/registration': '/registrierung',
        '/terms-and-conditions': '/agb',
        '/gdpr': '/gdpr',
        '/recover-password': '/passwort-wiederherstellen',
        '/personal-data-overview': '/kundendaten-uebersicht',
        '/personal-data-overview/:hash': '/kundendaten-uebersicht/:hash',
        '/personal-data-export': '/kundendaten-export',
        '/order-payment-confirmation': '/bestellung-zahlungsbestaetigung',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/bestelldetails/:urlHash',
        '/cookie-consent': '/cookie-zustimmung',
        '/abandoned-cart/:cartUuid': '/verlassener-Warenkorb/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/zahlungs-gateways',
        '/maintenance': '/wartung',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/beliebte-produkte',
        '/order-claim/detail/:urlHash': '/reklamation/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reklamation/neu/:urlHash',
        '/order-return/detail/:urlHash': '/waren-rueckgabe/detail/:urlHash',
        '/order-return/new/:urlHash': '/waren-rueckgabe/neu/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reklamation/bestaetigung/:urlHash',
        '/order-return/confirmation/:urlHash': '/waren-rueckgabe/bestaetigung/:urlHash',
        '/claims-and-returns': '/reklamationen-und-rueckgaben',
        '/legal-guarantee-notice': '/harmonisierte-mitteilung-gesetzliche-gewaehrleistung',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[15]?.url || process.env.DOMAIN_HOSTNAME_16]: {
        '/search': '/cautare',
        '/cart': '/cos',
        '/order/transport-and-payment': '/comanda/livrare-si-plata',
        '/order/contact-information': '/comanda/date-de-contact',
        '/reset-password': '/parola-uitata',
        '/order-confirmation': '/confirmare-comanda',
        '/stores': '/magazine',
        '/contact': '/contact',
        '/product-lines': '/linii-de-produse',
        '/catalog': '/catalog',
        '/login': '/autentificare',
        '/customer': '/client',
        '/customer/edit-profile': '/client/editare-profil',
        '/customer/orders': '/client/comenzi',
        '/customer/order-detail': '/client/detalii-comanda',
        '/customer/exchange-office': '/client/schimb-valutar',
        '/customer/my-points': '/client/punctele-mele',
        '/customer/watched-items': '/client/produse-urmarite',
        '/registration': '/inregistrare',
        '/terms-and-conditions': '/termeni-si-conditii',
        '/gdpr': '/protectia-datelor',
        '/recover-password': '/resetare-parola',
        '/personal-data-overview': '/prezentare-date-personale',
        '/personal-data-overview/:hash': '/prezentare-date-personale/:hash',
        '/personal-data-export': '/export-date-personale',
        '/order-payment-confirmation': '/confirmare-plata-comanda',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/detalii-comanda/:urlHash',
        '/cookie-consent': '/consimtamant-cookie-uri',
        '/abandoned-cart/:cartUuid': '/cos/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/produs/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/gateway-plata',
        '/maintenance': '/mentenanta',
        '/configurator': '/configurator-flexi',
        '/social-login': '/autentificare-sociala',
        '/wishlist': '/lista-de-dorinte',
        '/order-claim/detail/:urlHash': '/reclamatie/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamatie/nou/:urlHash',
        '/order-return/detail/:urlHash': '/retur-produse/detail/:urlHash',
        '/order-return/new/:urlHash': '/retur-produse/nou/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamatie/confirmare/:urlHash',
        '/order-return/confirmation/:urlHash': '/retur-produse/confirmare/:urlHash',
        '/claims-and-returns': '/reclamatii-si-retururi',
        '/legal-guarantee-notice': '/notificare-armonizata-garantie-legala',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[16]?.url || process.env.DOMAIN_HOSTNAME_17]: {
        '/search': '/zoeken',
        '/cart': '/winkelwagen',
        '/order/transport-and-payment': '/bestelling/verzending-en-betaling',
        '/order/contact-information': '/bestelling/contactgegevens',
        '/reset-password': '/wachtwoord-vergeten',
        '/order-confirmation': '/bestelbevestiging',
        '/stores': '/winkels',
        '/contact': '/contact',
        '/product-lines': '/productlijnen',
        '/catalog': '/catalogus',
        '/login': '/inloggen',
        '/customer': '/klant',
        '/customer/edit-profile': '/klant/profiel-bewerken',
        '/customer/orders': '/klant/bestellingen',
        '/customer/order-detail': '/klant/bestelgegevens',
        '/customer/exchange-office': '/klant/wisselkantoor',
        '/customer/my-points': '/klant/mijn-punten',
        '/customer/watched-items': '/klant/gevolgde-producten',
        '/customer/claims-and-returns': '/klant/reclamaties-en-retouren',
        '/customer/order-claim': '/klant/reclamatie',
        '/customer/order-return': '/klant/retour-producten',
        '/registration': '/registratie',
        '/terms-and-conditions': '/algemene-voorwaarden',
        '/gdpr': '/privacybeleid',
        '/recover-password': '/nieuw-wachtwoord',
        '/personal-data-overview': '/overzicht-persoonsgegevens',
        '/personal-data-overview/:hash': '/overzicht-persoonsgegevens/:hash',
        '/personal-data-export': '/export-persoonsgegevens',
        '/order-payment-confirmation': '/bevestiging-betaling-bestelling',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/bestelgegevens/:urlHash',
        '/cookie-consent': '/cookie-toestemming',
        '/abandoned-cart/:cartUuid': '/winkelwagen/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/betaalgateway',
        '/maintenance': '/onderhoud',
        '/configurator': '/flexi-configurator',
        '/social-login': '/sociaal-inloggen',
        '/wishlist': '/verlanglijst',
        '/order-claim/detail/:urlHash': '/reclamatie/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamatie/nieuwe/:urlHash',
        '/order-return/detail/:urlHash': '/retour-producten/detail/:urlHash',
        '/order-return/new/:urlHash': '/retour-producten/nieuwe/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamatie/bevestiging/:urlHash',
        '/order-return/confirmation/:urlHash': '/retour-producten/bevestiging/:urlHash',
        '/claims-and-returns': '/reclamaties-en-retouren',
        '/legal-guarantee-notice': '/geharmoniseerde-kennisgeving-wettelijke-garantie',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[17]?.url || process.env.DOMAIN_HOSTNAME_18]: {
        '/search': '/recherche',
        '/cart': '/panier',
        '/order/transport-and-payment': '/commande/livraison-et-paiement',
        '/order/contact-information': '/commande/informations-de-contact',
        '/reset-password': '/mot-de-passe-oublie',
        '/order-confirmation': '/confirmation-commande',
        '/stores': '/magasins',
        '/contact': '/contact',
        '/product-lines': '/gammes-de-produits',
        '/catalog': '/catalogue',
        '/login': '/connexion',
        '/customer': '/client',
        '/customer/edit-profile': '/client/modifier-profil',
        '/customer/orders': '/client/commandes',
        '/customer/order-detail': '/client/details-commande',
        '/customer/exchange-office': '/client/bureau-de-change',
        '/customer/my-points': '/client/mes-points',
        '/customer/watched-items': '/client/produits-suivis',
        '/customer/claims-and-returns': '/client/reclamations-et-retours',
        '/customer/order-claim': '/client/reclamation',
        '/customer/order-return': '/client/retour-produits',
        '/registration': '/inscription',
        '/terms-and-conditions': '/conditions-generales',
        '/gdpr': '/protection-des-donnees',
        '/recover-password': '/nouveau-mot-de-passe',
        '/personal-data-overview': '/aperçu-donnees-personnelles',
        '/personal-data-overview/:hash': '/aperçu-donnees-personnelles/:hash',
        '/personal-data-export': '/export-donnees-personnelles',
        '/order-payment-confirmation': '/confirmation-paiement-commande',
        '/order/payment-status-notify': '/order/payment-status-notify',
        '/order-detail/:urlHash': '/details-commande/:urlHash',
        '/cookie-consent': '/consentement-cookies',
        '/abandoned-cart/:cartUuid': '/panier/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/produit/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/passerelle-paiement',
        '/maintenance': '/maintenance',
        '/configurator': '/configurateur-flexi',
        '/social-login': '/connexion-sociale',
        '/wishlist': '/liste-de-souhaits',
        '/order-claim/detail/:urlHash': '/reclamation/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamation/nouvelle/:urlHash',
        '/order-return/detail/:urlHash': '/retour-produits/detail/:urlHash',
        '/order-return/new/:urlHash': '/retour-produits/nouveau/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamation/confirmation/:urlHash',
        '/order-return/confirmation/:urlHash': '/retour-produits/confirmation/:urlHash',
        '/claims-and-returns': '/reclamations-et-retours',
        '/legal-guarantee-notice': '/avis-harmonise-garantie-legale',
    },
    [nextConfig?.publicRuntimeConfig?.domains?.[18]?.url || process.env.DOMAIN_HOSTNAME_19]: {
        '/search': '/ricerca',
        '/cart': '/carrello',
        '/order/transport-and-payment': '/ordine/trasporto-e-pagamento',
        '/order/contact-information': '/ordine/dati-di-contatto',
        '/reset-password': '/recupera-password',
        '/order-confirmation': '/conferma-ordine',
        '/stores': '/negozi',
        '/contact': '/contattateci',
        '/product-lines': '/linee-di-prodotti',
        '/catalog': '/catalogo',
        '/login': '/accesso',
        '/customer': '/cliente',
        '/customer/edit-profile': '/cliente/modifica-profilo',
        '/customer/orders': '/cliente/ordini',
        '/customer/order-detail': '/cliente/dettaglio-ordine',
        '/customer/exchange-office': '/cliente/cambio-valuta',
        '/customer/my-points': '/cliente/i-miei-punti',
        '/customer/watched-items': '/cliente/articoli-osservati',
        '/customer/claims-and-returns': '/cliente/reclami-e-resi',
        '/customer/order-claim': '/cliente/reclamo',
        '/customer/order-return': '/cliente/reso-prodotti',
        '/registration': '/registrazione',
        '/terms-and-conditions': '/termini-e-condizioni',
        '/gdpr': '/regolamento-gdpr',
        '/recover-password': '/nuova-password',
        '/personal-data-overview': '/panoramica-dati-personali',
        '/personal-data-overview/:hash': '/panoramica-dati-personali/:hash',
        '/personal-data-export': '/esportazione-dati-personali',
        '/order-payment-confirmation': '/conferma-pagamento-ordine',
        '/order/payment-status-notify': '/notifica-stato-pagamento',
        '/order-detail/:urlHash': '/dettaglio-ordine/:urlHash',
        '/cookie-consent': '/consenso-cookie',
        '/abandoned-cart/:cartUuid': '/carrello/:cartUuid',
        '/tescoma-club': '/tescoma-club',
        '/products/:catNum': '/product/:catNum',
        '/products/:productCatNum': '/video/:productCatNum',
        '/paymentgate-start': '/gateway-di-pagamento',
        '/maintenance': '/manutenzione',
        '/configurator': '/flexi-config',
        '/social-login': '/social-login',
        '/wishlist': '/prodotti-desiderati',
        '/order-claim/detail/:urlHash': '/reclamo/detail/:urlHash',
        '/order-claim/new/:urlHash': '/reclamo/nuovo/:urlHash',
        '/order-return/detail/:urlHash': '/reso-prodotti/detail/:urlHash',
        '/order-return/new/:urlHash': '/reso-prodotti/nuovo/:urlHash',
        '/order-claim/confirmation/:urlHash': '/reclamo/conferma/:urlHash',
        '/order-return/confirmation/:urlHash': '/reso-prodotti/conferma/:urlHash',
        '/claims-and-returns': '/reclami-e-resi',
        '/legal-guarantee-notice': '/avviso-armonizzato-garanzia-legale',
    },
} as const;

export type StaticRewritePathKeyType = keyof (typeof STATIC_REWRITE_PATHS)[string];
